import {
  FormikInsertPlateBirth,
  FormikInsertPlateBirthMapper,
  ModalPlateBirthProps,
} from "src/types";
import { useTranslation } from "react-i18next";
import { AR_LINK } from "src/config";
import { useFormik } from "formik";
import { useModalPlateBirthValidationSchema } from "./validation-schemas/modal-plate-birth.hook";
import { useSearchParams } from "react-router";

export const useModalPlateBirth = ({ onConfirm }: ModalPlateBirthProps) => {
  const { t } = useTranslation();
  const onCloseModal = () => {
    window.location.replace(AR_LINK);
  };
  const [searchParams] = useSearchParams();

  const { schema: validationSchema } = useModalPlateBirthValidationSchema();
  const formikInsertData = useFormik<FormikInsertPlateBirth>({
    initialValues: {
      plate: searchParams.get("targa") || "",
      dateOfBirth: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setTouched, setSubmitting }) => {
      setTouched({});
      setSubmitting(false);
      onConfirm?.(FormikInsertPlateBirthMapper.toDTO(values));
    },
  });

  return { formikInsertData, t, onCloseModal };
};
